<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">Archive Feature</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">Max Chat Archive Time</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.maxChatArchiveTime" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">Chat Archive Time</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.chatArchiveTime" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            maxChatArchiveTime: 0,
            chatArchiveTime: 0,
        },
    }),
    mounted() {
        this.form = this.$_.cloneDeep(this.value);
        const feature = this.form.features.find((x) => x.type == "archive");
        this.featureForm = feature || this.featureForm;
    },
    watch: {
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: "archive", ...this.featureForm };
                if (parseInt(v.maxChatArchiveTime) > 0) response["maxChatArchiveTime"] = parseInt(v.maxChatArchiveTime);
                if (parseInt(v.chatArchiveTime) > 0) response["chatArchiveTime"] = parseInt(v.chatArchiveTime);
                const feature = this.form.features.findIndex((x) => x.type == "archive");
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else if (!this.$_.isEqual(v, this.form.features[feature])) {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
